import {
    EUserRole,
    type IUserAssistantModel,
    type IUserCoachModel,
    type IUserManagerModel,
    type IUserModel,
    type IUserParticipantModel
} from "@/3514/types"

function isUserParticipant(user: IUserModel): user is IUserParticipantModel {
    return !!user && user.role === EUserRole.Participant
}

function isUserCoach(user: IUserModel): user is IUserCoachModel {
    return !!user && user.role === EUserRole.Coach
}

function isUserManager(user: IUserModel): user is IUserManagerModel {
    return !!user && user.role === EUserRole.Manager
}

function isUserAssistant(user: IUserModel): user is IUserAssistantModel {
    return !!user && user.role === EUserRole.Assistant
}

export { isUserParticipant, isUserCoach, isUserManager, isUserAssistant }
